module.exports = "pegasus/assets/tech/basic_3/1.png";